import { useEffect, useState, useContext } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import { Card, Link, TextField, MenuItem, Box } from "@mui/material";
import {
  boxStyle,
  StyledTableCell,
  StyledTableRow,
  searchStyle,
  Root,
  headerStyle,
  buttonPosition,
} from "../style/style";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import GetAppIcon from "@mui/icons-material/GetApp";
import LoadingButton from "@mui/lab/LoadingButton";
import { loginContext, adminDrawerContext } from "../context/contexts";
import { getobj, dltobj, updateobj } from "../apicall/apicall";
import { getKeyByValue } from "../context/contextmanager";
import "react-notifications/lib/notifications.css";
import Pagination from "@mui/material/Pagination";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { timeStamp } from "../apicall/commonFunction";

export default function DeviceList() {
  const [devices, setdevices] = useState();
  const [search, setsearch] = useState(
    sessionStorage.getItem("search") ? sessionStorage.getItem("search") : "",
  );
  const [refresh, setrefresh] = useState(false);
  const [loaded, setloaded] = useState(true);
  const context = useContext(loginContext);
  const [page, setpage] = useState(
    sessionStorage.getItem("page_number")
      ? parseInt(sessionStorage.getItem("page_number"))
      : 1,
  );
  const [totalpage, setpaget] = useState();
  const [devicestatus, setdevicestatus] = useState("CONNECTED");
  const [isExporting, setIsExporting] = useState(false);

  const adminDrawer = useContext(adminDrawerContext);

  const handleClick = (id) => {
    context.setid(id);

    const nm = getKeyByValue(context.page, true);
    context.setpage({
      ...context.page,
      [nm]: false,
      deviceDetail: true,
    });
  };

  const handleaction = (id, val, type) => {
    //console.log(id, val, val === "Re-active");
    if (val === "Re-active") {
      const url = process.env.REACT_APP_ZEWA_URL + "device/add-device/";
      const data = { id: id, connection_status: "CONNECTED" };
      const res = updateobj(url, data);
      res.then(function (data) {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.success("Status Updated.", "Updated", 2000);

        setrefresh(!refresh);
      });
      // console.log(data);
    } else if (val === "Erase") {
      const url =
        process.env.REACT_APP_ZEWA_URL +
        "device/add-device/?delete_type=permanent";
      const res = dltobj(url, { id: id });
      res.then((r) => {
        if (r["Message"] === "Permanently deleted") {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success("Successfully deleted.", "Deleted", 2000);
          setrefresh(!refresh);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Could not deletd.", "Failed", 2000);
        }
      });
    } else if (val === "Detail") {
      sessionStorage.setItem("page", "DeviceList");
      sessionStorage.setItem("page_number", page);
      if (search.length > 0) {
        sessionStorage.setItem("search", search);
      }

      handleClick(id);
    } else if (val === "Delete") {
      if (type === "NA") {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.info(
          "The device will be permanently deleted after this billing period, To add it again contact Admin",
        );
      } else {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.info(
          "The Device and sim will be deactivated. The device will be permanently deleted after this billing period, To add it again contact Admin",
        );
      }
      const url = process.env.REACT_APP_ZEWA_URL + "device/add-device/";
      const res = dltobj(url, { id: id });
      res.then((r) => {
        if (r["Message"] === "Device deleted successfully") {
          // NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success("Successfully deleted.", "Deleted", 2000);
          setrefresh(!refresh);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Could not deletd.", "Failed", 2000);
        }
      });
    } else {
      // console.log("here");
      const url = process.env.REACT_APP_ZEWA_URL + "device/add-device/";
      let status;
      if (val === "Activate") {
        status = true;
      } else {
        status = false;
      }
      const data = { id: id, active_status: status };
      const res = updateobj(url, data);
      res.then(function (data) {
        if (data.status === 200) {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success(data.Message, "Updated", 2000);

          setrefresh(!refresh);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error(data.Message, "Failed", 2000);
        }
      });
    }
  };

  const handlePagechange = (event, value) => {
    setpage(value);
    let url = "";
    if (search === "") {
      url =
        process.env.REACT_APP_ZEWA_URL +
        "device/get-device/0/?page=" +
        value +
        "&status=" +
        devicestatus;
    } else {
      url =
        process.env.REACT_APP_ZEWA_URL +
        "device/get-device/0/?page=" +
        value +
        "&status=" +
        devicestatus +
        "&search=" +
        search;
    }

    const d = getobj(url);
    setloaded(true);
    d.then(function (res) {
      if (res && res.results && res.results.data) {
        setdevices(res.results.data);
        setloaded(false);
      } else {
        console.error("Invalid response structure:", res);
        setdevices([]);
        setloaded(false);
      }
    }).catch((err) => {
      console.error("Error fetching devices:", err);
      setdevices([]);
      setloaded(false);
    });
  };

  useEffect(() => {
    // Wait 500ms after the user stops typing before searching
    const delayDebounceFn = setTimeout((event) => {
      if (search.length > 0) {
        handlesearch(event);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [search]);

  useEffect(() => {
    if (search.length > 0) {
      const url =
        process.env.REACT_APP_ZEWA_URL +
        "device/get-device/0/?search=" +
        search +
        "&status=" +
        devicestatus +
        "&page=" +
        page;
      const d = getobj(url);
      d.then(function (res) {
        //  console.log(res);
        setdevices(res.results);
        if (res.count % 5 > 0) {
          setpaget(Math.floor(res.count / 5) + 1);
        } else {
          setpaget(Math.floor(res.count / 5));
        }

        setloaded(false);
      });
    } else {
      const url =
        process.env.REACT_APP_ZEWA_URL +
        "device/get-device/0/?page=" +
        page +
        "&status=" +
        devicestatus;
      const d = getobj(url);
      d.then(function (res) {
        //console.log(res);
        if (res.count % 5 > 0) {
          setpaget(Math.floor(res.count / 5) + 1);
        } else {
          setpaget(Math.floor(res.count / 5));
        }

        setdevices(res.results);
        setloaded(false);
      });
    }
  }, [refresh, page, devicestatus, search]);

  const handlesearch = (e) => {
    e?.preventDefault();
    setrefresh(!refresh);
    setloaded(true);
    setpage(1);
    if (search.length > 0) {
      const url =
        process.env.REACT_APP_ZEWA_URL +
        "device/get-device/0/?search=" +
        search +
        "&status=" +
        devicestatus;
      const d = getobj(url);
      d.then(function (res) {
        // console.log("Results -- ", res);
        if (res && res.results) {
          setdevices(res.results);
          setloaded(false);
          if (res.count % 5 > 0) {
            setpaget(Math.floor(res.count / 5) + 1);
          } else {
            setpaget(Math.floor(res.count / 5));
          }
        } else {
          console.error("Invalid response structure:", res);
          setdevices([]);
          setloaded(false);
        }
      }).catch((err) => {
        console.error("Error during search:", err);
        setdevices([]);
        setloaded(false);
      });
    }
  };
  const handleLink = (id) => {
    adminDrawer.setbuttonText("Organization");
    const nm = getKeyByValue(context.page, true);
    context.setid(id);
    context.setcustomer_id(id);
    context.setpage({
      ...context.page,
      [nm]: false,
      userDetail: true,
    });

    // const nm = getKeyByValue(context.page, true);
    // context.setpage({
    //   ...context.page,
    //   [nm]: false,
    //   ["userDetail"]: true,
    // });
  };

  const handleExport = async () => {
    try {
      setIsExporting(true);

      // Build query parameters
      let params = `status=${devicestatus}`;
      if (search && search.length > 0) {
        params += `&search=${encodeURIComponent(search)}`;
      }

      const url = `${process.env.REACT_APP_ZEWA_URL}device/export-devices/?${params}`;

      // Show feedback for potentially large exports
      const startTime = Date.now();

      const response = await getobj(url);

      const duration = (Date.now() - startTime) / 1000;
      console.log(
        `Export completed in ${duration}s for ${response.length} records`,
      );

      if (response && Array.isArray(response)) {
        // Convert array of arrays to CSV
        const csvContent = response
          .map((row) => {
            // Escape values that contain commas or quotes
            return row
              .map((cell) => {
                if (cell === null || cell === undefined) {
                  return "";
                }
                const cellStr = String(cell);
                if (cellStr.includes(",") || cellStr.includes('"')) {
                  return `"${cellStr.replace(/"/g, '""')}"`;
                }
                return cellStr;
              })
              .join(",");
          })
          .join("\n");

        // Create blob and download
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);

        const filename = `DeviceList_${devicestatus}_${new Date().getTime()}.csv`;
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        NotificationManager.success(
          "Devices exported successfully.",
          "Export Successful",
          2000,
        );
      } else {
        NotificationManager.error(
          "Invalid response from server.",
          "Export Failed",
          2000,
        );
      }
    } catch (error) {
      console.error("Error exporting devices:", error);
      NotificationManager.error(
        "Failed to export devices.",
        "Export Failed",
        2000,
      );
    } finally {
      setIsExporting(false);
    }
  };

  const hubContent = (device) => {
    if (device.hub_id === null) {
      return "NA";
    } else if (devicestatus === "CONNECTED" && !device.hub_id.delete_status) {
      return (
        <Link
          onClick={() => {
            context.sethub(device.hub_id["id"]);
            const nm = getKeyByValue(context.page, true);
            context.setpage({
              ...context.page,
              [nm]: false,
              HubDevices: true,
            });
          }}
        >
          {device.hub_id["hub_id"]}
        </Link>
      );
    } else {
      return device.hub_id["hub_id"];
    }
  };

  return (
    <Root>
      {loaded ? (
        <img
          src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif"
          alt="loading..."
        />
      ) : (
        <Root>
          <Card sx={boxStyle}>
            <Card sx={headerStyle}>
              Device List
              <form onSubmit={handlesearch} style={searchStyle}>
                <FormControl variant="standard" sx={searchStyle}>
                  <InputLabel htmlFor="input-with-icon-adornment">
                    Search Device
                  </InputLabel>
                  <Input
                    id="input-with-icon-adornment"
                    startAdornment={
                      <InputAdornment position="start">
                        <SearchSharpIcon color="primary" />
                      </InputAdornment>
                    }
                    value={search}
                    onChange={(e) => {
                      setsearch(e.target.value);
                    }}
                  />
                </FormControl>
              </form>
            </Card>
          </Card>

          <br />
          <Box sx={boxStyle}>
            <select
              value={devicestatus}
              onChange={(e) => {
                setdevicestatus(e.target.value);
                setpage(1);
                setrefresh(!refresh);
              }}
            >
              <option value="CONNECTED">Working Device</option>
              <option value="DISCONNECTED">Deleted Device</option>
            </select>
            <Box sx={buttonPosition}>
              {devices && devices.length > 0 && (
                <LoadingButton
                  onClick={handleExport}
                  loading={isExporting}
                  endIcon={<GetAppIcon />}
                  variant="contained"
                  color="primary"
                  sx={{ margin: "5px" }}
                >
                  Export Device List
                </LoadingButton>
              )}
            </Box>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>
                      <b>Company Name</b>
                    </StyledTableCell>
                    <StyledTableCell>
                      <b>Device Group</b>
                    </StyledTableCell>
                    <StyledTableCell>
                      <b>Model</b>
                    </StyledTableCell>
                    <StyledTableCell>
                      <b>Bluetooth ID</b>
                    </StyledTableCell>
                    <StyledTableCell>
                      <b>IMEI</b>
                    </StyledTableCell>
                    <StyledTableCell>
                      <b>Hub</b>
                    </StyledTableCell>

                    <StyledTableCell>
                      <b>Status</b>
                    </StyledTableCell>
                    <StyledTableCell>
                      <b> Last Active</b>
                    </StyledTableCell>
                    {/* <StyledTableCell>
                      <b>Comments</b>
                    </StyledTableCell> */}
                    <StyledTableCell></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {devices
                    ? devices.map((device) => (
                        <StyledTableRow key={device.id}>
                          <StyledTableCell>
                            <Link
                              onClick={() => {
                                handleLink(device.customer_id);
                              }}
                            >
                              {device.company_name}
                            </Link>
                          </StyledTableCell>
                          <StyledTableCell>{device.group}</StyledTableCell>
                          <StyledTableCell>{device.model}</StyledTableCell>
                          <StyledTableCell>
                            {device.mac_address}
                          </StyledTableCell>
                          <StyledTableCell>
                            {device.imei_number}
                          </StyledTableCell>
                          <StyledTableCell>
                            {hubContent(device)}
                          </StyledTableCell>
                          <StyledTableCell>
                            {device.active_status === false
                              ? "Inactive"
                              : "Active"}
                          </StyledTableCell>
                          <StyledTableCell>
                            {device.imei_number === "NA"
                              ? timeStamp(parseInt(device.utc))
                              : timeStamp(parseInt(device.utc, 16))}
                            {/* {device.last_active.split("T")[0]} */}
                          </StyledTableCell>
                          {/* <StyledTableCell>{device.comments}</StyledTableCell> */}
                          <StyledTableCell>
                            <Button
                            // variant="contained"
                            // onClick={() => {
                            //   handleClick(device.id);
                            // }}
                            >
                              <TextField
                                select
                                name="device_name"
                                id="deviceName"
                                sx={{ width: "clamp(80px, 12vw, 100px)" }}
                                variant="outlined"
                                label="Action"
                                value={""}
                                onChange={(e) => {
                                  handleaction(
                                    device.id,
                                    e.target.value,
                                    device.imei_number,
                                  );
                                }}
                              >
                                <MenuItem value="Detail">Detail</MenuItem>
                                {devicestatus === "CONNECTED" && (
                                  <MenuItem
                                    value={
                                      device.active_status
                                        ? "Deactivate"
                                        : "Activate"
                                    }
                                  >
                                    {device.active_status
                                      ? "Deactivate"
                                      : "Activate"}
                                  </MenuItem>
                                )}
                                <MenuItem
                                  value={
                                    device.connection_status === "CONNECTED"
                                      ? "Delete"
                                      : "Re-active"
                                  }
                                >
                                  {device.connection_status === "CONNECTED"
                                    ? "Terminate"
                                    : "Re-active"}
                                </MenuItem>
                                {device.connection_status ===
                                  "DISCONNECTED" && (
                                  <MenuItem value="Erase">Erase</MenuItem>
                                )}
                              </TextField>
                            </Button>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))
                    : null}
                </TableBody>
                <Pagination
                  count={totalpage}
                  page={page}
                  variant="outlined"
                  color="primary"
                  onChange={handlePagechange}
                />
              </Table>
            </TableContainer>
            <NotificationContainer />
          </Box>
        </Root>
      )}
    </Root>
  );
}
